<template>
    <NavbarMain />

    <PresentationSectionSmallerImage :photo="first_section_image_en" :title="first_section_title_en"
        :content="first_section_content_en" />

    <GeneralContactForm />

    <div class="columns-4-section">
        <PhotoCardsHeader :section_title="third_section_title_en" :section_content="third_section_content_en" />

        <PhotoCards :section_image="third_section_box_image_en" :button_title="third_section_box_title_en"
            :button_text="third_section_box_content_en" :button_link="third_section_box_link_en" />
    </div>

    <FooterPage />
</template>

<script>
import axios from 'axios';

import FooterPage from '@/components/FooterPage.vue';
import NavbarMain from '@/components/NavbarMain.vue';
import GeneralContactForm from '@/components/GeneralContactForm.vue';
import PhotoCards from '@/components/PhotoCards.vue';
import PhotoCardsHeader from '@/components/PhotoCardsHeader.vue';
import PresentationSectionSmallerImage from '@/components/PresentationSectionSmallerImage.vue';

export default {
    components: {
        NavbarMain,
        FooterPage,
        GeneralContactForm,
        PhotoCards,
        PhotoCardsHeader,
        PresentationSectionSmallerImage
    },
    data() {
        return {
            contactUsData: { items_en: [{}] },
            first_section_image_en: '',
            first_section_title_en: '',
            first_section_content_en: '',
            third_section_title_en: '',
            third_section_content_en: '',
            third_section_box_image_en: '',
            third_section_box_title_en: '',
            third_section_box_content_en: '',
            third_section_box_link_en: '',
        }
    },
    mounted() {
        const token = process.env.VUE_APP_WEBSITE_TOKEN;
        const API_URL = process.env.VUE_APP_WEBSITE_HOSTNAME;

        axios.get(`${API_URL}/api/contact-us-content`, {
            headers: {
                'Authorization': `Token ${token}`,
            },
        })
            .then(response => {
                this.contactUsData = response.data || { items_en: [] };

                if (this.contactUsData.items_en[0]?.active === true) {
                    this.first_section_title_en = this.contactUsData.items_en[0].first_section_title;
                    this.first_section_content_en = this.contactUsData.items_en[0].first_section_content;
                    this.first_section_image_en = this.contactUsData.items_en[0].first_section_image;
                    this.third_section_title_en = this.contactUsData.items_en[0].third_section_title;
                    this.third_section_content_en = this.contactUsData.items_en[0].third_section_content;
                    this.third_section_box_image_en = this.contactUsData.items_en[0].third_section_box_image;
                    this.third_section_box_title_en = this.contactUsData.items_en[0].third_section_box_title;
                    this.third_section_box_content_en = this.contactUsData.items_en[0].third_section_box_content;
                    this.third_section_box_link_en = this.contactUsData.items_en[0].third_section_box_link;
                }
            })
            .catch(error => {
                console.error('Error fetching Contact US data:', error);
            });
    }
}
</script>

<style>
@import '@/css/main.css';

.columns-4-section {
    display: grid;
    grid-template-columns: 1fr 1fr;
    justify-content: center;
    align-items: center;
    gap: 10px;
    padding: auto;
}

@media all and (max-width: 850px) {
    .columns-4-section {
        display: grid;
        grid-template-columns: 1fr;
        gap: 10px;
    }
}
</style>
